import {each, set, find} from 'lodash';
import i18n from 'i18n';
import {isHttp, isEmail} from 'types/transport/Transport';
import {hasDateParam} from 'common/dateUtils';
import {hasSourceSeqParam, hasDestinationSeqParam} from 'common/seqUtils';
import {ALL_FILES_RECURSIVE, UNIX_SEP, WINDOWS_SEP} from 'common/constants';
import {getDirectory, getFilename} from 'common/utils';

import {enums} from 'types/enums';
import {ITransaction} from './Transaction';

const wildCardCharsRegexp = /(\*|\?)/;
const dirWildcardRegex = /(\*|\?|\||(\[\*\]))/;
const dateRegexp = /<DATE>/g;
const seqRegexp = /<SEQ>/g;

const wildcardRegexp = /(\*|\?|<SEQ>|<DATE>)/;
export const doesThisSourceUseWildcards = (source: string) => wildcardRegexp.test(source);

export const doesSourceTextUseNonFiniteWildcards = (s: string, sourceDateRange: string) => {
   if (wildCardCharsRegexp.test(s) || s === ALL_FILES_RECURSIVE || hasSourceSeqParam(s)) {
      return true;
   } else if (hasDateParam(s)) {
      // sourceDateRange is finit (if All)
      return sourceDateRange === enums.sourceDateRange.enum.ALL;
   }
};

const isDirectoryWildcarded = (path: string, sourcePath: boolean) => {
   const dirPath = getDirectory(path);
   if (dirWildcardRegex.test(dirPath)) {
      if (sourcePath) {
         return hasSourceSeqParam(dirPath);
      } else {
         return hasDestinationSeqParam(dirPath);
      }
   }
   return false;
};

export const validateTransaction = (values: ITransaction) => {
   const errors = {};

   if (!find(values.fileDescriptors, (fD) => !!fD.sourceFilename)) {
      set(
         errors,
         `fileDescriptors[0].sourceFilename`,
         i18n.t('At least one non-blank source filename must be supplied')
      );
      return errors;
   }

   each(values.fileDescriptors, (fileDescriptor, i) => {
      if (
         isHttp(values.sourcePartner.transport) &&
         doesSourceTextUseNonFiniteWildcards(fileDescriptor.sourceFilename, values.sourceDateRange)
      ) {
         set(
            errors,
            `fileDescriptors[${i}].sourceFilename`,
            i18n.t(
               'Source filename cannot contain wildcards, non-finite date parameters or ' +
                  'sequence parameters when transport method is HTTP or HTTPS'
            )
         );
      } else if (
         isEmail(values.sourcePartner.transport) &&
         fileDescriptor.sourceFilename === ALL_FILES_RECURSIVE
      ) {
         //if transport is email source cannot specify recursive directories
         set(
            errors,
            `fileDescriptors[${i}].sourceFilename`,
            i18n.t("Source filename cannot contain use '**' when transport method is Email")
         );
      } else if (isDirectoryWildcarded(fileDescriptor.sourceFilename, true)) {
         //directory portion of path cannot contain wildcards other than date
         set(
            errors,
            `fileDescriptors[${i}].sourceFilename`,
            i18n.t(
               'Source filename cannot contain wildcards or sequence ' +
                  'parameters within directory names'
            )
         );
      } else if (
         fileDescriptor._patternType !== enums.patternType.enum.REGEX &&
         (fileDescriptor.sourceFilename?.indexOf(UNIX_SEP) === 0 ||
            fileDescriptor.sourceFilename?.indexOf(WINDOWS_SEP) === 0)
      ) {
         //source path cannot start with separator
         set(
            errors,
            `fileDescriptors[${i}].sourceFilename`,
            i18n.t('Source filename cannot start with / or \\')
         );
      }

      // if (!isEmpty(errors)) {
      //   return errors;
      // }

      // verify usage of date param in source filename (vs directories)
      const fileName = getFilename(fileDescriptor.sourceFilename);
      const matches = dateRegexp.exec(fileName);
      if (matches && matches.length) {
         let count = 1;
         while (dateRegexp.exec(fileName)) {
            count++;
         }

         if (count > 1) {
            set(
               errors,
               `fileDescriptors[${i}].sourceFilename`,
               i18n.t('Source filename cannot contain more than 1 <DATE> parameter')
            );
         } else if (!values.sourceDateFormat) {
            set(
               errors,
               `sourceDateFormat`,
               i18n.t(
                  'When <DATE> is used in source filename the date format field cannot be blank'
               )
            );
         }
      }

      const dir = getDirectory(fileDescriptor.sourceFilename);
      const dirMatches = dateRegexp.exec(dir);
      if (dirMatches && dirMatches.length) {
         if ([enums.sourceDateRange.enum.ALL].includes(values.sourceDateRange as 'ALL')) {
            set(
               errors,
               `sourceDateRange`,
               i18n.t(
                  'When <DATE> is used in source directory name the ' +
                     'Source Date Range must not be ALL'
               )
            );
         } else if (!values.sourceDateFormat) {
            set(
               errors,
               `sourceDateFormat`,
               i18n.t(
                  'When <DATE> is used in source filename the date format field cannot be blank'
               )
            );
         }
      }

      const seqMatches = seqRegexp.exec(fileDescriptor.sourceFilename);
      if (seqMatches && seqMatches.length) {
         let count = 1;
         while (seqRegexp.exec(fileDescriptor.sourceFilename)) {
            count++;
         }

         if (count > 1) {
            set(
               errors,
               `fileDescriptors[${i}].sourceFilename`,
               i18n.t('Source filename cannot contain more than 1 <SEQ> parameter')
            );
         } else {
            // set(errors, `sourceDateFormat`, i18n.t("When <SEQ> is used in source filename the date format field cannot be blank"));
         }
      }
   });

   return errors;
};
